var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallExportDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.84 6.91A2.16 2.16 0 0 1 16 9.07v7.437a2.16 2.16 0 0 1-2.16 2.16H6.16A2.16 2.16 0 0 1 4 16.507V9.069a2.16 2.16 0 0 1 2.16-2.16H8v1.47H6.94A1.44 1.44 0 0 0 5.5 9.82v5.938c0 .795.645 1.44 1.44 1.44h6.12a1.44 1.44 0 0 0 1.44-1.44V9.819a1.44 1.44 0 0 0-1.44-1.44H12v-1.47h1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.448 1.625a.72.72 0 0 1 .116.116l2.01 2.531a.72.72 0 0 1-.565 1.168l-1.24-.001a.72.72 0 0 1 .039.231v6.398a.72.72 0 0 1-.72.72h-.176a.72.72 0 0 1-.72-.72V5.67a.72.72 0 0 1 .038-.231H7.99a.72.72 0 0 1-.563-1.167l2.01-2.53a.72.72 0 0 1 1.01-.117z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallExportDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-export-default.310fbd62ee2359c792e8aef92baf00f9.svg";